const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export async function createShareLink(inputs, label) {
  const res = await fetch(`${API}/plans`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ inputs, label }),
  });
  if (!res.ok) throw new Error("share failed");
  const { id } = await res.json();
  return `${window.location.origin}${window.location.pathname}?plan=${id}`;
}

export async function fetchSharedPlan(id) {
  const res = await fetch(`${API}/plans/${id}`);
  if (!res.ok) throw new Error("not found");
  const data = await res.json();
  return data.inputs;
}

export async function copyToClipboard(text) {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    return false;
  }
}
